import type { UIComponent } from '../schemas/base';

/**
 * Events emitted during streaming
 */
export type GenUIEvent =
    | { type: 'text_delta'; value: string }
    | { type: 'component'; payload: UIComponent }
    | { type: 'done' };

/**
 * Create a text delta event
 */
export function textDelta(value: string): GenUIEvent {
    return { type: 'text_delta', value };
}

/**
 * Create a component event
 */
export function componentEvent(payload: UIComponent): GenUIEvent {
    return { type: 'component', payload };
}

/**
 * Create a done event
 */
export function doneEvent(): GenUIEvent {
    return { type: 'done' };
}
